module.exports = __webpack_public_path__ + "img/user-empty.51c4843c.jpg";